module.exports = __webpack_public_path__ + "static/media/cardlevel.30669988.svg";